<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" :md="universityStudiesInformation !== null ? '6' : '12'">
        <v-card
          outlined
          class="rounded-xl d-inline-block overflow-hidden"
          style="z-index: 3"
          min-height="100%"
          min-width="100%"
        >
          <v-card-title>
            Предыдущее образование
          </v-card-title>
          <v-spacer/>
          <v-card-text class="text-body-1" v-if="!Array.isArray(pastEducation)">
            {{pastEducation}}
          </v-card-text>
          <template v-else>
            <v-card-text
              class="text-body-1 d-flex"
              v-for="education in pastEducation" :key="education.edu_string"
            >
              <v-divider vertical class="mr-2"/>
              {{education.edu_string}}
            </v-card-text>
          </template>
          <div class="card-img">
            <past-education/>
          </div>
        </v-card>
      </v-col>
      <v-col cols="12" md="6" v-if="universityStudiesInformation !== null">
        <v-card
          outlined
          class="rounded-xl d-inline-block overflow-hidden"
          style="z-index: 3"
          min-height="100%"
          min-width="100%"
        >
          <v-card-title>
            Обучение (Направление подготовки / специальность, Форма обучения, Год начала/окончания обучения)
          </v-card-title>
          <v-spacer/>
          <v-card-text class="text-body-1">
            {{universityStudiesInformation}}
          </v-card-text>
          <v-card-text v-if="'files' in universityStudies">
            <template v-if="universityStudies.files !== null">
              <v-chip-group v-if="universityStudies.files.file_aspirant.length > 0">
                <v-chip
                    v-for="(file, index) in universityStudies.files.file_aspirant" :key="file.url"
                    small
                    :href="file.url"
                    target="_blank"
                >
                  {{file.name}}
                </v-chip>
              </v-chip-group>
              <v-chip-group v-if="universityStudies.files.file_magister.length > 0">
                <v-chip
                    v-for="(file, index) in universityStudies.files.file_magister" :key="file.url"
                    small
                    :href="file.url"
                    target="_blank"
                >
                  {{file.name}}
                </v-chip>
              </v-chip-group>
            </template>
            <template v-else>
              <v-btn
                href="/study/plan"
                elevation="0"
                :color="$store.state.achievement.side_color"
                class="white--text"
              >
                Добавить индивидуальный план
              </v-btn>
            </template>
          </v-card-text>
          <div class="card-img">
            <university-icon/>
          </div>
        </v-card>
      </v-col>
      <v-col cols="12" v-if="specEmployer!== null">
        <v-card
            outlined
            class="rounded-xl d-inline-block overflow-hidden"
            style="z-index: 3"
            min-height="100%"
            min-width="100%"
        >
          <v-card-title>
            Преподавание
          </v-card-title>
          <v-card-text class="text-body-1">
            <v-simple-table>
              <template v-slot:default>
                <thead>
                <tr>
                  <th class="text-left">
                    Название
                  </th>
                  <th class="text-left">
                    Описание
                  </th>
                </tr>
                </thead>
                <tbody>
                <tr>
                  <td><v-chip><v-icon small class="mr-2">fa fa-briefcase</v-icon>Должность</v-chip></td>
                  <td class="text-body-1"><div v-html="specEmployer.title"></div></td>
                </tr>
                <tr>
                  <td><v-chip><v-icon small class="mr-2">fa fa-star</v-icon>Ученая степень</v-chip></td>
                  <td class="text-body-1"><div v-html="specEmployer.degree1"></div></td>
                </tr>
                <tr>
                  <td><v-chip><v-icon small class="mr-2">fa fa-flask</v-icon>Ученая звание</v-chip></td>
                  <td class="text-body-1"><div v-html="specEmployer.degree2"></div></td>
                </tr>
                <tr>
                  <td><v-chip><v-icon small class="mr-2">fa fa-graduation-cap</v-icon>Образование</v-chip></td>
                  <td class="text-body-1"><div v-html="specEmployer.level"></div></td>
                </tr>
                <tr>
                  <td><v-chip><v-icon small class="mr-2">fa fa-cogs</v-icon>Специальность</v-chip></td>
                  <td class="text-body-1"><div v-html="specEmployer.specialities"></div></td>
                </tr>
                <tr>
                  <td><v-chip><v-icon small class="mr-2">fa fa-certificate</v-icon>Квалификация</v-chip></td>
                  <td class="text-body-1"><div v-html="specEmployer.qualification"></div></td>
                </tr>
                <tr>
                  <td><v-chip><v-icon small class="mr-2">fa fa-suitcase</v-icon>Индивидуальный план</v-chip></td>
                  <td>
                    <v-chip-group v-if="specEmployer.files !== null">
                      <v-chip
                        v-for="(file, index) in specEmployer.files" :key="file.url"
                        small
                        :color="$store.state.achievement.side_color"
                        :href="file.url"
                        target="_blank"
                        class="white--text"
                      >
                        {{file.name}}
                      </v-chip>
                    </v-chip-group>
                  </td>
                </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card-text>

        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {mapState, mapGetters} from "vuex";
import PastEducation from "../Icons/PastEducation";
import UniversityIcon from "../Icons/UniversityIcon"

export default {
  name: "PersonalInfoTab",

  components: {
    PastEducation,
    UniversityIcon,
  },

  data() {
    return {
      pastEducation: null,
      universityStudies: null,
      specEmployer: null,
    };
  },

  mounted() {
    this.pastEducation = this.personalInfo?.past_education;
    this.universityStudies = this.personalInfo?.university_studies;
    this.specEmployer = this.personalInfo?.spec_employer;
  },

  computed: {
    ...mapGetters({
      personalInfo: "portfolio/personalInfo",
    }),

    universityStudiesInformation() {
      if (this.universityStudies === null) return null;

      const speciality_name = this.universityStudies?.educational_programm?.speciality_name;
      const edu_form = this.universityStudies?.edu_form?.name ;
      const study_year = this.universityStudies?.study_year?.name;
      return `${speciality_name} - ${edu_form} - ${study_year}`
    },

  },
}
</script>

<style scoped>
.card-img {
  bottom: 0;
  right: 0;
  position: absolute;
  z-index: -1;
  object-fit: contain;
  opacity: 0.05;
  overflow: hidden;
  transform: translate(25px, 25px);
}
</style>